import { combineReducers } from 'redux';

import type { Reducer } from 'Lib/reduxType';

import { getCommonResetAction } from 'Store/commonActions';

import { CLEAR_FILTERS, SET_FILTERS, TOGGLE_IS_FILTERS_OPEN } from './constants';
import initialState from './initialState';
import type { FiltersState } from './types';

const filtersReducer: Reducer<FiltersState['filterOptions']> = (
  state = initialState.filterOptions,
  action
) => {
  switch (action.type) {
    case SET_FILTERS:
      return action.payload ?? state;
    case CLEAR_FILTERS:
    case getCommonResetAction(action.type):
      return initialState.filterOptions;
    default:
      return state;
  }
};

const isFiltersOpenReducer: Reducer<FiltersState['isFiltersOpen']> = (
  state = initialState.isFiltersOpen,
  action
) => {
  switch (action.type) {
    case TOGGLE_IS_FILTERS_OPEN:
      return action.payload.toggle;
    case getCommonResetAction(action.type):
      return initialState.isFiltersOpen;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  filterOptions: filtersReducer,
  isFiltersOpen: isFiltersOpenReducer,
});
